import styles from "./PaneCollapseToggle.module.css";

export type TogglePosition = "top" | "left" | "right" | "bottom" | "none";

type PaneCollapseToggleProps = {
  paneId: string;
  onToggle: (id: string) => void;
  position: TogglePosition;
  isOpen: boolean;
  disabled?: boolean;
};

const PaneCollapseToggle = ({
  paneId,
  onToggle,
  position,
  disabled,
  isOpen,
}: PaneCollapseToggleProps) => {
  const onClickHandler = () => {
    onToggle(paneId);
  };

  return (
    <span
      onClick={onClickHandler}
      className={`
        ${styles.toggler} 
        ${styles[position]} 
        ${isOpen ? styles.open : ""} 
        ${disabled ? styles.disabled : "cursor-pointer"}
      `}
    ></span>
  );
};

export default PaneCollapseToggle;
